
import { TextSectionEntityDecorator } from './text-section.decorator';
import { TextSection } from './text-section.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class TextSectionTypeInfoBase implements CrudTypeInfo<TextSection, string> {
  name = 'Text Section';
  entityDecorator = new TextSectionEntityDecorator();
  
  createAuthorities = ['WRITE_TEXT_SECTION'];
  editAuthorities = ['WRITE_TEXT_SECTION'];
  deleteAuthorities = ['WRITE_TEXT_SECTION'];
  viewAuthorities = ['READ_TEXT_SECTION'];
  
  searchRouteBase = ['/textsection/search'];
  createRouteBase = ['/textsection/create'];
  editRouteBase = ['/textsection/edit'];
  viewRouteBase = ['/textsection/view'];
  
  description(item: TextSection): string {
    return '' +  item.id;
  }
}



